import axios from 'axios';
import { logger } from '../utils/logger';

const TX_API_BASE = import.meta.env.VITE_TX_BFF_URL || '/tx-api';

export const txApiClient = axios.create({
  baseURL: TX_API_BASE,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

/**
 * Interceptor for adding Mock Auth Token if VITE_MOCK_AUTH is enabled.
 */
txApiClient.interceptors.request.use(async (config) => {
  if (import.meta.env.VITE_MOCK_AUTH === 'true') {
    config.headers.Authorization = 'Bearer valid-token';
  } else {
    try {
      const { getFirebaseAuth } = await import('../lib/firebase');
      const { getIdToken } = await import('firebase/auth');
      const auth = getFirebaseAuth();
      if (auth.currentUser) {
        const token = await getIdToken(auth.currentUser);
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Firebase not initialized or user not logged in
    }
  }
  return config;
});

/**
 * Response interceptor for global error handling.
 */
txApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      logger.error(`TX API Error [${status}]`, error, { 
        url: error.config?.url,
        message: data?.error?.message 
      });
      
      if (data?.error?.code === 'AUTH_006') {
        window.location.href = '/login?message=concurrent_logout';
      } else if (status === 401 && import.meta.env.VITE_MOCK_AUTH !== 'true') {
        window.location.href = '/login';
      }
    } else {
      logger.error('TX Network/Server Error', error);
    }
    return Promise.reject(error);
  }
);
